import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import BrandingWatermarkOutlinedIcon from "@mui/icons-material/BrandingWatermarkOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import GradientOutlinedIcon from "@mui/icons-material/GradientOutlined";
import CompareOutlinedIcon from "@mui/icons-material/CompareOutlined";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";

/**
 * One icon and one colour per item kind (= per module), used wherever a
 * kind is shown: the accent stripe of its cards, the Modules entries of the
 * side menu, the tiles, tags and counts of the landing and Projects pages.
 * Three muted hues either side of the app's default blue (#4C7EFF, the
 * selected entry of the side menu): a steel blue for explorations, that
 * blue for selections, a dusty indigo for reproductions. Kept quiet on
 * purpose: a page of fifty cards must not glare. `accent` is the tone of
 * tiles, icons, tags and stripes; `header` a deeper tone for the few places
 * that carry white text on it; `tint` a faint wash.
 */
export const ITEM_KIND_STYLES = {
    exploration: {
        label: "Explorations",
        singular: "exploration",
        Icon: SearchOutlinedIcon,
        accent: "#3F96BF",
        header: "#2E6F8E",
        tint: "rgba(63, 150, 191, 0.07)",
    },
    selection: {
        label: "Selections",
        singular: "selection",
        Icon: FilterAltOutlinedIcon,
        accent: "#4C7EFF",
        header: "#2552CC",
        tint: "rgba(76, 126, 255, 0.07)",
    },
    reproduction: {
        label: "Reproductions",
        singular: "reproduction",
        Icon: BrandingWatermarkOutlinedIcon,
        accent: "#7A6BD0",
        header: "#5A4BB0",
        tint: "rgba(122, 107, 208, 0.07)",
    },
};

/** The icon of each selection type, keyed like SELECTION_KINDS. */
export const SELECTION_KIND_ICONS = {
    logo: BrandingWatermarkOutlinedIcon,
    modeContrast: CompareOutlinedIcon,
    manual: TouchAppOutlinedIcon,
    image: ImageOutlinedIcon,
};

/** The icon of each reproduction type, keyed like REPRODUCTION_KINDS. */
export const REPRODUCTION_KIND_ICONS = {
    logo: BrandingWatermarkOutlinedIcon,
    image: ImageOutlinedIcon,
    gradient: GradientOutlinedIcon,
};
